import React from 'react';
import { MapPin, Phone, Clock, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-foreground text-background pt-8 pb-16 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Logo and Description */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 rounded-full bg-gradient-primary flex items-center justify-center shadow-soft">
                <span className="text-xl font-bold text-primary-foreground">E</span>
              </div>
              <div>
                <h3 className="text-lg font-bold">Clínica Estética Eranza</h3>
              </div>
            </div>
            <p className="text-sm text-background/70 leading-relaxed">
              Tu clínica de confianza en Valencia para tratamientos de estética facial, corporal y medicina estética.
            </p>
          </div>

          {/* Dirección */}
          <div className="space-y-4">
            <h4 className="text-base font-semibold flex items-center gap-2">
              <MapPin className="w-5 h-5 text-primary" />
              Ubicación Principal
            </h4>
            <div className="text-sm text-background/70 space-y-2">
              <p>Av. de Jacinto Benavente, 19</p>
              <p>Bajo, 46005 Valencia</p>
              <p>España</p>
            </div>
          </div>

          {/* Contacto */}
          <div className="space-y-4">
            <h4 className="text-base font-semibold flex items-center gap-2">
              <Phone className="w-5 h-5 text-primary" />
              Contacto
            </h4>
            <div className="text-sm text-background/70 space-y-2">
              <a
                href="tel:+34637285137"
                className="block hover:text-primary transition-colors"
              >
                670 26 17 58
              </a>
              <a
                href="https://wa.me/34637285137"
                target="_blank"
                rel="noopener noreferrer"
                className="block hover:text-primary transition-colors"
              >
                WhatsApp directo
              </a>
            </div>
          </div>

          {/* Horario */}
          <div className="space-y-4">
            <h4 className="text-base font-semibold flex items-center gap-2">
              <Clock className="w-5 h-5 text-primary" />
              Horario
            </h4>
            <div className="text-sm text-background/70 space-y-2">
              <p>Lunes - Viernes:</p>
              <p className="font-medium">10:00 - 14:00</p>
              <p className="font-medium">16:00 - 20:00</p>
              <p className="mt-2">Sábados:</p>
              <p className="font-medium">10:00 - 14:00</p>
            </div>
          </div>
        </div>

        {/* Social Media */}
        <div className="border-t border-background/10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background/60">
              © {new Date().getFullYear()} Clínica Estética Eranza. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6">
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="text-background/70 hover:text-primary transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://wa.me/34637285137"
                target="_blank"
                rel="noopener noreferrer"
                className="text-background/70 hover:text-primary transition-colors"
                aria-label="WhatsApp"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;